import React, { useEffect } from "react";
import { Box, Flex, Heading, FormLabel } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeTagModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createTagRequest,
  editTagRequest,
} from "../../../../modules/admin-modules/tags/Actions";

const AddTag = ({ isAdd, data, setSelectedData }) => {
  const openTag = useSelector((state) => state.model.isOpen24);
  const isLoading = useSelector((state) => state.adminTags.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (!isAdd && data?.name) {
      setValue("name", data.name);
    }
  }, [data, isAdd, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة علامة" : "تعديل علامة"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeTagModel());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      let formData = new FormData();
      formData.append("name", values?.name);
      await dispatch(createTagRequest(formData, action));
    } else {
      let formData = new FormData();
      formData.append("_method", "PUT");
      formData.append("name", values?.name);
      dispatch(
        editTagRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeTagModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTag}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="100%">
            <MainInput
              label="اسم العلامة"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="ادخل اسم العلامة"
              register={register}
              name="name"
              required
            />
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddTag;

